import {
  Autocomplete,
  InputLabel,
  TextField,
  Box,
  CircularProgress,
  Popper,
  Tooltip,
} from '@mui/material';
import React, { useRef } from 'react';
import Theme from '../../../Themes/main.theme';
import { DropdownOptions, IFormController } from '../types';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
  
export interface MyMultiSelectOptions extends IFormController {
    customLabel?: boolean;
    multiple?: boolean;
    disableClearable?: boolean;
    freeSolo?: boolean;
    id?: string;
    groupByElement?: string;
    filtersDesign?: boolean;
    selectedItem?: any;
    required?: boolean;
    error?: any;
    isLoading?: boolean;
  }
  
  
const AutoCompleteSelect = (props: MyMultiSelectOptions) => {
  const {
    label, name, options, required, selectedItem, customLabel, info, filtersDesign,
    isLoading, ...rest } = props;
  
  const LOADER_SIZE = 20;

  const { t } = useTranslation();

  const emptyMsg = isLoading ? 
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <CircularProgress size={LOADER_SIZE} />
    </Box>
    : t('Μη διαθέσιμες επιλογές');  
  
  const reference = useRef<HTMLDivElement>(null);
  const PopperMy = React.useCallback((props: any) => {
    return <Popper {...props}
      style={{ width: reference?.current?.clientWidth, position: 'absolute', backgroundColor: 'inherit' }}
      placement='bottom-start'
    />;
  }, []);
    
  const [value, setValue] = React.useState(props.formik?.initialValues?.[props.name]
    ? props.formik?.initialValues?.[props.name]
    : '');
    
  const [inputValue, setInputValue] = React.useState('');
      
  const handleChange = (newValue: any) => {
    setValue(newValue);
    if (newValue) {
      props.formik?.setFieldValue(name, newValue.value);
    } else {
      props.formik?.setFieldValue(name, null);
    }
    selectedItem && selectedItem(newValue);
    props?.formik?.setTouched({ [props.name]: true });
  };

  React.useEffect(() => {
    if (
      props.formik?.initialValues[name] &&
      options &&
      options?.length > 0 &&
      options?.find(x => x.value === (props.formik?.initialValues[name]))
    ) {
      const val = options?.find(x => x.value === (props.formik?.initialValues[name]));
      setValue(val);
    }

  }, [options]);

  return (
    <Box>
      {
        customLabel
          ? <Box display='flex' alignItems='center'>
            <InputLabel
              htmlFor={props.name}
              disabled={props.disabled}
              required={required}
              sx={{
                my: customLabel
                  ? 2
                  : 0,
                textAlign: 'left',
                textStyle: 'none',
              }}
            >
              {label}
            </InputLabel>
            {info ? 
              <Tooltip
                PopperProps={{
                  disablePortal: true
                }} title={props?.tooltip}
                placement='right-start'>
                <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
              </Tooltip>
              : null
            }
          </Box> 
          : null
      }
      <div ref={reference}
        style={{ position: 'relative' }} >
        <Autocomplete
          sx={{
            ...(filtersDesign && {
              '& .MuiOutlinedInput-root': {
                '& > fieldset': {
                  borderRadius: '24px'
                }
              }
            })
          }}
          PopperComponent={PopperMy}
          noOptionsText={emptyMsg}
          disablePortal
          {...rest}
          value={props?.formik?.values[props.name]
            ? value
            : ''}
          disableClearable={!!value}
          onChange={(event: any, newValue: DropdownOptions) => {
            handleChange(newValue);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          options={options || []}
          getOptionLabel={(option: any) => option.key || ''}
          fullWidth
          renderInput={(params) => <TextField {...params} label={customLabel
            ? null
            : label} />}
        />
      </div>
    </Box>
  );
};
  
export default AutoCompleteSelect;